import axios from 'axios';
import { API_URL } from '../config/api.config';

const getAuthInfo = () => {
    const garageId = JSON.parse(localStorage.getItem('user') || '{}')._id || ''
    const token = localStorage.getItem('token');
    return { garageId, token };
};

const createAuthAxios = () => {
    const { token } = getAuthInfo();
    return axios.create({
        baseURL: API_URL,
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
};
const authAxios = createAuthAxios()

export const notificationService = {
    // Récupérer toutes les notifications pour l'utilisateur courant
    async getNotifications() {
        try {
            const { garageId } = getAuthInfo();
            const response = await authAxios.get(`/notification/user/${garageId}`);
            return response.data.notifications || [];
        } catch (error) {
            console.error('Erreur lors de la récupération des notifications:', error);
            throw error;
        }
    },

    // Récupérer le nombre de notifications non lues
    async getUnreadCount() {
        try {
            const { garageId } = getAuthInfo();
            const response = await authAxios.get(`/notification/user/${garageId}/unread-count`);
            return response.data.count || 0;
        } catch (error) {
            console.error('Erreur lors de la récupération du nombre de notifications non lues:', error);
            throw error;
        }
    },

    // Marquer une notification comme lue
    async markAsRead(notificationId: string) {
        try {
            const response = await authAxios.put(`/notification/${notificationId}/read`);
            return response.data.notification;
        } catch (error) {
            console.error('Erreur lors du marquage de la notification comme lue:', error);
            throw error;
        }
    },

    // Marquer toutes les notifications comme lues
    async markAllAsRead() {
        try {
            const { garageId } = getAuthInfo();
            const response = await authAxios.put(`/notification/user/${garageId}/read-all`);
            return response.data;
        } catch (error) {
            console.error('Erreur lors du marquage de toutes les notifications comme lues:', error);
            throw error;
        }
    },

    // Supprimer une notification
    async deleteNotification(notificationId: string) {
        try {
            const { garageId } = getAuthInfo();
            const response = await authAxios.delete(`/notification/${notificationId}`);
            return response.data;
        } catch (error) {
            console.error('Erreur lors de la suppression de la notification:', error);
            throw error;
        }
    },

    // Supprimer toutes les notifications
    async clearAllNotifications() {
        try {
            const { garageId } = getAuthInfo();
            const response = await authAxios.delete(`/notification/user/${garageId}/clear-all`);
            return response.data;
        } catch (error) {
            console.error('Erreur lors de la suppression de toutes les notifications:', error);
            throw error;
        }
    }
};